// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"cd6807c9","112":"23af67ca","135":"c55305ba","180":"a14d9a62","249":"1cb29aff","337":"86548042","394":"43efb39c","440":"acbdad60","609":"b17769e7","645":"0d533ecf","711":"1c1a1503","725":"807fee3e","802":"e792a02f","934":"f4f930b6"}[chunkId] + ".chunk.js";
};